(function () {
  var locale = (window.__SF_LOCALE || 'tr').toLowerCase();
  if (locale.indexOf('en') !== 0) return;

  var EXT = /(\.(?:png|jpe?g|webp|gif))(?=(?:\?|$))/i;

  function enVersion(u) {
    if (!u || u.indexOf('-en.') > -1 || !EXT.test(u)) return null;
    return u.replace(EXT, '-en$1');
  }

  function swap(img) {
    if (img.dataset.sfI18n) return;
    img.dataset.sfI18n = '1';

    var origSrc = img.getAttribute('src');
    var cand = enVersion(origSrc);
    if (!cand) return;

    var origSrcset = img.getAttribute('srcset');

    var reverted = false;
    function revert() {
      if (reverted) return;
      reverted = true;
      img.setAttribute('src', origSrc);
      if (origSrcset) img.setAttribute('srcset', origSrcset);
      img.removeEventListener('error', onErr);
    }
    function onErr() { revert(); }

    img.addEventListener('error', onErr);
    img.setAttribute('src', cand);
    if (origSrcset) {
      img.setAttribute('srcset', origSrcset.replace(new RegExp(EXT.source, 'gi'), '-en$1'));
    }
  }

  function scan(root) {
    var imgs = root.querySelectorAll ? root.querySelectorAll('img') : [];
    for (var i = 0; i < imgs.length; i++) swap(imgs[i]);
  }

  scan(document);
  document.addEventListener('DOMContentLoaded', function () { scan(document); });

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var nodes = muts[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType !== 1) continue;
        if (n.tagName === 'IMG') swap(n); else scan(n);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();